import axios from 'axios';
import { DEV_SERVER } from '../../../../constants/urls';
import { userSignal } from '../../../../signal/userSignal';
import { getDealers } from '../../../../utilities/getDealers';
import { tsConstructorType } from '@babel/types';
import { TallyConfig } from '../helpers/constants';
import { stateNameFormatter } from '../../../../utilities/stateNameFormatter';
import { GetLedgers } from '../services/ledger';
const hash = require('object-hash');

export async function SyncLedgers(ledgers) {


    try {

        if (!ledgers) {
            console.log("Ledgers not found")
            return false
        }

        ledgers = ledgers?.ENVELOPE?.BODY?.DATA?.COLLECTION?.LEDGER || []

        if (!(ledgers instanceof Array)) {
            ledgers = [ledgers]
        }

        if(ledgers.length === 0){
            return true
        }

        let data = []

        for (let i = 0; i < ledgers.length; i++) {
            let ledger = ledgers[i]

            console.log(ledger)

            let dealer = {
                name: ledger?._attributes?.NAME,
                state: ledger?.LEDSTATENAME?._text || "",
                pincode: ledger?.PINCODE?._text || "",
                phoneNumber: ledger?.LEDGERMOBILE?._text || "",
                group: ledger?.PARENT?._text || "",
            }
            
            dealer.phoneNumber = parseInt(dealer.phoneNumber) || 0
            
            if (dealer?.name !== "") {
                dealer.state = stateNameFormatter(dealer.state)    
            }
            
            dealer.tallyDetails = [{
                masterId: ledger?.MASTERID?._text || "",
                guId: ledger?.GUID?._text || "",
                companyName: TallyConfig.company || "",
                remoteId: ledger?.REMOTEALTGUID?._text || "",
                alterId: ledger?.ALTERID?._text || "",
                priceLevel: ledger?.PRICELEVEL?._text || "",
            }]

            if (ledger["ADDRESS.LIST"]?.ADDRESS) {

                if (ledger["ADDRESS.LIST"]?.ADDRESS?.length > 0) {
                    dealer.address = ledger["ADDRESS.LIST"]?.ADDRESS?.map((address) => address?._text).join(", ") || ""
                } else {
                    dealer.address = ledger["ADDRESS.LIST"].ADDRESS._text
                }
            }

            if (ledger?.["PARTYGSTIN"]?._text !== "") {
                dealer.gstin = ledger?.["PARTYGSTIN"]?._text || ""
            }

            if(!dealer?.gstin || dealer?.gstin === "") {
                if(ledger?.["LEDGSTREGDETAILS.LIST"] && ledger?.["LEDGSTREGDETAILS.LIST"]?.GSTIN) {
                    dealer.gstin = ledger?.["LEDGSTREGDETAILS.LIST"]?.GSTIN?._text || ""
                }
            }

            if(dealer?.state === "") {
                
                if(ledger?.["LEDMAILINGDETAILS.LIST"] && ledger?.["LEDMAILINGDETAILS.LIST"]?.STATE) {
                    let state = ledger?.["LEDMAILINGDETAILS.LIST"]?.STATE?._text || ""
                    dealer.state = stateNameFormatter(state)
                }
            }

            if (dealer?.pincode === "") {
                if(ledger?.["LEDMAILINGDETAILS.LIST"] && ledger?.["LEDMAILINGDETAILS.LIST"]?.PINCODE) {
                    dealer.pincode = ledger?.["LEDMAILINGDETAILS.LIST"]?.PINCODE?._text || ""
                }
            }

            if (dealer?.pincode !== "") {
                dealer.pincode = parseInt(dealer.pincode)
            } else {
                dealer.pincode = 0
            }

            data.push(dealer)
        }

        let resp = await window.electron.grpcConnect({
            userId: userSignal?.value?.user.id,
            organisationId: userSignal?.value?.user?.organisation,
            reqType: "syncDealers",
            dealers: JSON.stringify(data),
        })

        // wait for 2s
        await new Promise((resolve, reject) => {
            setTimeout(async () => {
                resolve()
            }, 5000)
        })

        return
    } catch (err) {
        console.log(err)
        return false
    }
}